import React, { useEffect, useState } from 'react';
import { Table, Card, Spinner, Alert, Button } from 'react-bootstrap';
import axiosInstance from '../../utils/axiosConfig';

const BulkOrdersAdmin = () => {
  const [bulkOrders, setBulkOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  useEffect(() => {
    fetchBulkOrders(page, limit);
    // eslint-disable-next-line
  }, [page, limit]);

  const fetchBulkOrders = async (page, limit) => {
    setLoading(true);
    try {
      const response = await axiosInstance.get('/bulk-orders', {
        params: { page, limit }
      });
      setBulkOrders(response.data.bulkOrders);
      setTotalPages(response.data.pagination.totalPages);
      setTotalItems(response.data.pagination.totalItems);
      setLoading(false);
    } catch (err) {
      setError('Failed to load bulk order requests');
      setLoading(false);
    }
  };

  const handlePrevious = () => {
    if (page > 1) setPage(page - 1);
  };

  const handleNext = () => {
    if (page < totalPages) setPage(page + 1);
  };

  if (loading) {
    return (
      <Card className="shadow-sm mb-4">
        <Card.Body className="text-center py-5">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </Card.Body>
      </Card>
    );
  }

  if (error) {
    return (
      <Card className="shadow-sm mb-4">
        <Card.Body>
          <Alert variant="danger">{error}</Alert>
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card className="shadow-sm mb-4">
      <Card.Body>
        <h4 className="card-title mb-4">Bulk Order Requests</h4>
        <Table responsive hover>
          <thead>
            <tr>
              <th>Name</th>
              <th>Contact</th>
              <th>Email</th>
              <th>City</th>
              <th>User Type</th>
              <th>Requirements</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {bulkOrders.length === 0 ? (
              <tr>
                <td colSpan="7" className="text-center text-muted">No bulk order requests found.</td>
              </tr>
            ) : (
              bulkOrders.map(order => (
                <tr key={order.id}>
                  <td>{order.user_name}</td>
                  <td>{order.contact_number}</td>
                  <td>{order.email}</td>
                  <td>{order.city}</td>
                  <td>{order.userType}</td>
                  <td style={{ maxWidth: 300, whiteSpace: 'pre-line' }}>{order.requirement}</td>
                  <td>{order.created_at ? new Date(order.created_at).toLocaleString() : ''}</td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
        {/* Pagination Controls */}
        <div className="d-flex justify-content-between align-items-center mt-3">
          <div>
            Showing page {page} of {totalPages} ({totalItems} requests)
          </div>
          <div>
            <Button
              variant="outline-primary"
              size="sm"
              onClick={handlePrevious}
              disabled={page === 1}
              className="me-2"
            >
              Previous
            </Button>
            <Button
              variant="outline-primary"
              size="sm"
              onClick={handleNext}
              disabled={page === totalPages || totalPages === 0}
            >
              Next
            </Button>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default BulkOrdersAdmin; 